export default function CourseCardSkeleton() {
  return (
    <div className="relative w-full aspect-[3/4] min-h-[400px] rounded-3xl overflow-hidden border border-slate-200 dark:border-zinc-800 bg-slate-100 dark:bg-zinc-900 animate-pulse">
      {/* Thumbnail area */}
      <div className="absolute inset-0 bg-zinc-200 dark:bg-zinc-800" />

      {/* Top badges */}
      <div className="absolute top-5 left-5 right-5 flex justify-between items-start z-10">
        <div className="h-7 w-16 rounded-lg bg-zinc-300/50 dark:bg-zinc-700/50" />
        <div className="h-7 w-14 rounded-lg bg-zinc-300/50 dark:bg-zinc-700/50" />
      </div>

      {/* Bottom content */}
      <div className="absolute bottom-0 w-full p-5 z-10 bg-gradient-to-t from-zinc-300/80 dark:from-zinc-900/90 via-zinc-300/40 dark:via-zinc-900/40 to-transparent pt-20">
        {/* Title lines */}
        <div className="h-6 w-[85%] rounded-lg bg-zinc-300 dark:bg-zinc-700 mb-3" />
        <div className="h-5 w-[55%] rounded-lg bg-zinc-300 dark:bg-zinc-700 mb-4" />

        {/* Meta row: duration/units/lessons */}
        <div className="flex items-center gap-4 mb-4">
          <div className="h-4 w-20 rounded bg-zinc-300/70 dark:bg-zinc-700/70" />
          <div className="h-4 w-16 rounded bg-zinc-300/70 dark:bg-zinc-700/70" />
          <div className="h-4 w-14 rounded bg-zinc-300/70 dark:bg-zinc-700/70" />
        </div>

        {/* Divider */}
        <div className="h-px w-full bg-zinc-300/50 dark:bg-zinc-700/50 mb-4" />

        {/* Bottom row: avatar + name | students */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-zinc-300 dark:bg-zinc-700" />
            <div className="h-4 w-20 rounded bg-zinc-300 dark:bg-zinc-700" />
          </div>
          <div className="h-4 w-16 rounded bg-zinc-300 dark:bg-zinc-700" />
        </div>
      </div>
    </div>
  );
}
